export default {"src":"/_next/static/media/group_white.8d68c122.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};